import DivingDads from './DivingDads/DivingDads'

const App = () => {
  return <DivingDads />
}

export default App
